import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFourKitesControl extends Layout {
    sourceFourkitesControl: DataSource;
    tableFourKitesControl: Table;
}
